import React, { Component } from 'react';
import List from 'components/common/List';
import { propOr } from 'ramda';

import { GET_PROJECT_LIST } from 'constants/actionTypes';
import ProjectListControls from 'components/views/projectList/ProjectListControls';
import ProjectMassListControls from 'components/views/projectMass/ProjectMassListControls';

export default class ProjectList extends Component {
    renderControls = (props) => {
        const { getList: { meta, type } } = this.props;
        const { match: { params: { id } } } = this.props;

        return type === GET_PROJECT_LIST ? (
            <ProjectListControls {...props} id={id} refreshMeta={meta} />
        ) : (
            <ProjectMassListControls {...props} id={id} refreshMeta={meta} />
        );
    }

    render() {
        const { getList: { data, meta }, getSettings: { data : settings }, tableConfig } = this.props;

        return (
            <List
                meta={meta}
                items={propOr([], 'projects', data)}
                settings={settings}

                tableConfig={tableConfig}
                controls={this.renderControls}

                {...this.props}
            />
        );
    }
}
